define(() => {
    "use strict";

    return {
        TAGS: {DIV: "div", SPAN: "span"},
        HEADINGS: ["h1", "h2", "h3", "h4", "h5", "h6"],
        HIGH_LIGHT_CLASS: "highlight",
        INLINE_STYLES: ["font-size", "font-weight", "font-style", "font-family", "color", "letter-spacing", "text-decoration", "font-variant", "text-transform", "text-shadow"],
        BLOCK_STYLES: ["text-align", "line-height"],
        // "data-customfontid", "data-path" and "data-format" are reserved for custom fonts.
        // "data-kitid" is reserved for TypeKit
        // "data-projectid" is reserved for Fonts.com
        INLINE_ATTRIBUTES: ["data-font-provider", "data-customfontid", "data-path", "data-format", "data-kitid", "data-font-family", "data-projectid"],
        INHERIT: "inherit",
        ADDSTYLE: "addStyle"
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/textWidget/textEditor/TextEditorConstants.js